import styled from "@emotion/native";
import Text from "../Text";

export const Container = styled.View({
	marginBottom: 32,
});

export const Header = styled.View({
	marginBottom: 26,
});

export const Title = styled(Text)({
	marginBottom: 4,
});

export const Body = styled(Text)({});

export const Main = styled.View({
	paddingHorizontal: 40,
});

export const Divider = styled.View({
	width: "100%",
	height: 1,
	marginTop: 16,
	backgroundColor: "#a7a7a7",
	opacity: 0.4,
});
